module.exports = __webpack_public_path__ + "static/media/team-dina.2163962e.jpg";